import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { logger } from './logger';

const errText = (e) => {
    const d = e?.response?.data?.detail;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' · ');
    return d || e?.message || 'Hata';
};

/** 📐 Aralık Botu: durum (10 sn'de bir) + aksiyonlar (coin ekle/sil, başlat/durdur, pozisyon kapat). */
export function useRangeBot() {
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        try {
            const { data } = await apiClient.get('/range/status');
            setStatus(data);
        } catch (e) {
            logger.warn('range status failed', e);
        }
    }, []);

    const act = useCallback(async (fn) => {
        setBusy(true);
        setError(null);
        try {
            const r = await fn();
            await load();
            return r;
        } catch (e) {
            setError(errText(e));
            throw e;
        } finally {
            setBusy(false);
        }
    }, [load]);

    const start = useCallback((mode) => act(() => apiClient.post('/range/start', { mode })), [act]);
    const stop = useCallback((close) => act(() => apiClient.post('/range/stop', { close: !!close })), [act]);
    const saveCoin = useCallback((coin) => act(() => apiClient.post('/range/coins', coin)), [act]);
    const deleteCoin = useCallback((id) => act(() => apiClient.delete(`/range/coins/${id}`)), [act]);
    const saveSettings = useCallback((patch) => act(() => apiClient.put('/range/settings', patch)), [act]);
    const closePos = useCallback((id) => act(() => apiClient.post(`/range/positions/${id}/close`)), [act]);
    const bulkCoins = useCallback((patch) => act(() => apiClient.put('/range/coins/bulk', patch)), [act]);
    const patchCoin = useCallback((id, patch) => act(() => apiClient.patch(`/range/coins/${id}`, patch)), [act]);
    const orderCoins = useCallback((ids) => act(() => apiClient.put('/range/coins/order', { ids })), [act]);

    useEffect(() => {
        load();
        const id = setInterval(load, 10000);
        return () => clearInterval(id);
    }, [load]);

    return { status, busy, error, reload: load, start, stop, saveCoin, deleteCoin, saveSettings, closePos, bulkCoins, patchCoin, orderCoins };
}
